
export function useRequestAnimationFrame(fn: Function, throttle = true) {
	let isRunning: boolean = false;
	let that: any;
	let args: IArguments;

	function run() {
		isRunning = false;
		fn.apply(that, args);
	}

	return function() {
		that = this;
		args = arguments;

		if (isRunning && throttle) {
			return;
		}

		isRunning = true;
		requestAnimationFrame(run);
	};
}
